export class PartiallyConstructible {
    /** @internal */
    _marker() { }
}
/** @internal */
export function mapRTUUIResult(result, LClass) {
    if (result.status === 'OK') {
        return Object.assign(Object.assign({}, result), { data: new LClass(result.data) });
    }
    else {
        return result;
    }
}
/** @internal */
export function mapRTUUIListResult(result, LClass) {
    if (result.status === 'OK') {
        return Object.assign(Object.assign({}, result), { data: result.data.map((i) => new LClass(i)) });
    }
    else {
        return result;
    }
}
/** @internal */
export function mapPlainResult(jsObject) {
    return jsObject.result;
}
export class Point {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
}
//# sourceMappingURL=utils.js.map